import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ZEN_ICONS } from "@/components/IconLibrary";

export function IconPickerModal({ open, onOpenChange, onSelect, onReset }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="cms-dialog icon-picker-dialog">
        <DialogHeader>
          <DialogTitle>Choose an icon</DialogTitle>
          <DialogDescription>Pick from a curated pool of zen-inspired icons for this practice.</DialogDescription>
        </DialogHeader>
        <div className="icon-picker-grid">
          <button type="button" className="icon-picker-reset" onClick={onReset} data-testid="icon-picker-reset-button">
            Default
          </button>
          {Object.entries(ZEN_ICONS).map(([name, Icon]) => (
            <button
              key={name}
              type="button"
              className="icon-picker-item"
              onClick={() => onSelect(name)}
              title={name}
              data-testid={`icon-picker-item-${name}`}
            >
              <Icon strokeWidth={1.6} />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
